import React from 'react'
import { NewAppLayout } from '@/components/new-ux/layout/NewAppLayout'
import { ComprehensiveDashboard } from "@/components/comprehensive-dashboard/ComprehensiveDashboard"

const ComprehensiveDashboardPage = () => {
  return (
    <NewAppLayout fullWidth>
      <ComprehensiveDashboard />
    </NewAppLayout>
  )
}

export default ComprehensiveDashboardPage
